import { createElementBlock as t, openBlock as s, normalizeClass as r, renderSlot as o } from "vue";
import { _ as a } from "./_plugin-vue_export-helper-CHgC5LLL.js";
const c = "_separator_5w47w_2", l = {
  separator: c
}, n = {
  name: "ll-divider"
};
function p(e, i, _, f, m, u) {
  return s(), t("div", {
    class: r(["tw-flex tw-items-center tw-text-center tw-uppercase", e.$style.separator]),
    role: "separator"
  }, [
    o(e.$slots, "default")
  ], 2);
}
const d = {
  $style: l
}, v = /* @__PURE__ */ a(n, [["render", p], ["__cssModules", d]]);
export {
  v as default
};
//# sourceMappingURL=Divider.js.map
